import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-notification-settings-panel',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './notification-settings-panel.component.html',
  styleUrls: ['./notification-settings-panel.component.css']
})
export class NotificationSettingsPanelComponent implements OnChanges {
  @Input() isOpen: boolean = false;
  @Input() channelId: string = '';
  @Output() closePanel = new EventEmitter<void>();

  muteNotifications: boolean = false;
  muteCalls: boolean = false;

  get isDarkMode(): boolean {
    if (typeof document === 'undefined') return true;
    return (
      document.body.classList.contains('dark-theme') ||
      document.documentElement.classList.contains('dark-theme') ||
      !document.body.classList.contains('light-theme')
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && this.isOpen) {
      this.loadSettings();
    }
  }

  loadSettings(): void {
    const cid = this.channelId || 'global';
    const muteN = localStorage.getItem(`mute_notifications_${cid}`);
    const muteC = localStorage.getItem(`mute_calls_${cid}`);
    this.muteNotifications = muteN === 'true';
    this.muteCalls = muteC === 'true';
  }

  toggleMuteNotifications(): void {
    this.muteNotifications = !this.muteNotifications;
    const cid = this.channelId || 'global';
    localStorage.setItem(`mute_notifications_${cid}`, String(this.muteNotifications));
  }

  toggleMuteCalls(): void {
    this.muteCalls = !this.muteCalls;
    const cid = this.channelId || 'global';
    localStorage.setItem(`mute_calls_${cid}`, String(this.muteCalls));
  }

  onClose(): void {
    this.closePanel.emit();
  }
}
